import { Col, Row,} from "antd";
import { useGetContractByType } from "../../ServerSideStates";
import { FC } from "react";

const ContractPaymentDescription:FC<{containerClassNames?:string}> = ({containerClassNames}) => {

      const contract =  useGetContractByType("1003")
  
  const html = contract?.data?.data ? contract.data.data?.content : "";
  
 
  return (
    <Col xs={24}>
      <Row className={containerClassNames?containerClassNames:"!px-16"} gutter={[20, 20]}>
        <Col xs={24}>
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </Col>
      </Row>

    </Col>
  );
}
 
export default ContractPaymentDescription;